module.exports = __webpack_public_path__ + "img/rewardful-logo.a701d60d.svg";